<script setup lang="ts">
import type { UiOption } from "@/types/ui"
import UiFieldWrapper from "./UiFieldWrapper.vue"

const model = defineModel<string | number | "">({ default: "" })

withDefaults(
  defineProps<{
    id: string
    label: string
    options: UiOption[]
    placeholder?: string
    required?: boolean
    disabled?: boolean
    allowEmpty?: boolean
    emptyLabel?: string
    error?: string
    helperText?: string
  }>(),
  {
    placeholder: "Selecione...",
    required: false,
    disabled: false,
    allowEmpty: false,
    emptyLabel: "Todos",
    error: "",
    helperText: "",
  }
)
</script>

<template>
  <UiFieldWrapper :label="label" :for-id="id" :error="error" :helper-text="helperText">
    <select
      :id="id"
      v-model="model"
      :required="required"
      :disabled="disabled"
      class="w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 transition focus:border-slate-400 focus:outline-none"
    >
      <option v-if="allowEmpty" value="">{{ emptyLabel }}</option>
      <option v-else value="" disabled>{{ placeholder }}</option>
      <option v-for="option in options" :key="String(option.value)" :value="option.value">
        {{ option.label }}
      </option>
    </select>
  </UiFieldWrapper>
</template>

